<template>
    <v-breadcrumbs :items="items" divider=">">
        <template #item="{ item }">
            <a href="#" @click.prevent.stop="$emit('click', item)">
                <span class="tgk-paragraph-text">{{ item.title }}</span>
            </a>
        </template>
    </v-breadcrumbs>
</template>

<script>
import { Album } from '@/models/Album';

export default {
    name: 'AlbumBreadcrumbs',
    props: {
        selectedAlbum: {
            type: Album,
            required: false,
        },
    },

    data() {
        return {
            items: [],
        };
    },

    watch: {
        selectedAlbum(act) {
            this.createItemList(act);
        },
    },

    mounted() {
        this.createItemList(this.selectedAlbum);
    },

    methods: {
        createItemList(album) {
            // create a reverse item list by traversing the album tree up:
            let items = [];
            while (album) {
                items = [album, ...items];
                album = album.parent;
            }
            this.items = items;
        },
    },
};
</script>

<style lang="scss" scoped>
a {
    text-decoration-line: none;
}
</style>
